import React from 'react'

export default () => (
  <svg  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="Arrow / Arrow_Right_LG">
    <path id="Vector" d="M21 12L16 7M21 12L16 17M21 12H3" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  </svg>
)